import ResultItem from './result-item';

export default ResultItem;
